module.exports = __webpack_public_path__ + "img/card_4.bb2b542f.png";